import { Heading } from '@/components/catalyst-ui/heading'
import { Text } from '@/components/catalyst-ui/text'
import { RadioGroup, RadioField, Radio } from '@/components/catalyst-ui/radio'
import { Badge } from '@/components/catalyst-ui/badge'
import PaymentSummary from './PaymentSummary'
import { calculatePeriodPrice, calculatePrivacyPrice, calculateTotalPrice, getPerYearPrice } from '../utils/priceCalculations'

export default function PrivacyStep({ formData, setFormData, domainPriceData, domain }) {
  const privacyPrice = 3
  const basePrice = domainPriceData?.price || 0
  const prices = domainPriceData?.prices || {}
  const selectedPeriodPrice = calculatePeriodPrice(formData.period, basePrice, prices)
  const perYear = getPerYearPrice(selectedPeriodPrice, formData.period)
  const privacyTotal = calculatePrivacyPrice(formData.period, formData.whois_privacy, privacyPrice)
  const totalPrice = calculateTotalPrice(selectedPeriodPrice, privacyTotal)

  const summaryItems = [
    {
      label: `${formData.period} Year ($${perYear.toFixed(2)}/year):`,
      price: selectedPeriodPrice
    },
    {
      label: formData.whois_privacy ? 'Private Registration:' : 'Public Registration:',
      price: formData.whois_privacy ? privacyTotal : 0
    }
  ]

  return (
    <div className="flex flex-col items-center gap-4">
      <div className="text-center">
        <Heading level={3} className="!text-3xl !font-semibold text-gray-900">{domain} will soon be yours</Heading>
        <Text className="mt-2 !text-[#A1A1AA] !font-medium">Protect your personal information and enhance security.</Text>
      </div>

      <div className="w-full max-w-md">
        <style>{`
          .custom-radio-override [data-slot="control"] > span {
            --radio-checked-bg: #5C33FF !important;
            --radio-checked-border: #5C33FF !important;
          }
        `}</style>
        <RadioGroup
          value={formData.whois_privacy ? 'private' : 'public'}
          onChange={(value) => setFormData(prev => ({ ...prev, whois_privacy: value === 'private' }))}
          className="custom-radio-override space-y-3"
        >
          <div
            className={`rounded-lg border-2 p-3 transition-colors cursor-pointer relative ${
              formData.whois_privacy ? 'border-[#5C33FF] bg-[#5C33FF]/5' : 'border-[#E4E4E7] bg-[#FAFAFA]'
            }`}
            onClick={() => setFormData(prev => ({ ...prev, whois_privacy: true }))}
          >
            <div className="absolute top-4 left-3">
              <Radio 
                value="private" 
                color="violet" 
                data-slot="control"
                className="custom-radio-override"
              />
            </div>
            <div className="pl-8">
              <div className="flex items-center justify-between">
                <Text className="!text-sm !font-semibold text-zinc-900 dark:text-white">Private registration</Text>
                <Badge color="green" className="ml-2 !text-xs !font-semibold !py-1 !px-1.5 !bg-[#D1FAE5] !text-[#047857]">Recommended</Badge>
              </div>
              <Text className="!text-sm !font-medium !text-black">${privacyPrice} per year</Text>
              <ul className="mt-1 space-y-1 text-xs font-medium text-[#71717A] pl-2">
                <li>• Hides your personal info (name, email, address) from public records.</li>
                <li>• Helps prevent spam calls and emails.</li>
              </ul>
            </div>
          </div>

          <div
            className={`rounded-lg -mt-1 border-2 p-3 transition-colors cursor-pointer relative ${
              !formData.whois_privacy ? 'border-[#5C33FF] bg-[#5C33FF]/5' : 'border-[#E4E4E7] bg-[#FAFAFA]'
            }`}
            onClick={() => setFormData(prev => ({ ...prev, whois_privacy: false }))}
          >
            <div className="absolute top-3 left-3">
              <Radio 
                value="public" 
                color="violet" 
                data-slot="control"
                className="custom-radio-override"
              />
            </div>
            <div className="pl-8">
              <Text className="!text-sm !font-semibold !text-black">Public registration</Text>
              <Text className="!text-sm !font-medium !text-black">FREE</Text>
              <Text className="mt-1 !text-xs !font-medium !text-[#71717A]">
                Warning: Your personal contact information will be publicly visible online in the WHOIS database.
              </Text>
            </div>
          </div>
        </RadioGroup>
      </div>

      {/* Summary section */}
      <PaymentSummary
        items={summaryItems}
        total={totalPrice}
        showPerYear={true}
      />
    </div>
  )
}
